import React, { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import {
  Button,
  Stack,
  Box,
  Typography,
  CircularProgress,
  Container,
} from "@mui/material";

import withDialog from "../commonComponents/withDialog";
import { extractErrorMessage } from "../utils/utils";
import serviceEndpoints from "../services/serviceEndpoints";
import constant from "../utils/constants";

const ConfirmationPopup = ({ onConfirm, loading }) => {
  return (
    <Box>
      <Typography>Are you sure you want to upload this file?</Typography>
      <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
        <Button variant="outlined" onClick={() => onConfirm(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(true)}
          disabled={loading}
        >
          Yes, Upload
        </Button>
      </Stack>
    </Box>
  );
};

const ConfirmationDialog = withDialog(ConfirmationPopup, "Confirm Upload");

const UploadImdComponent = () => {
  const [file, setFile] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  // Function for downloading csv template
  const handleDownload = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}${serviceEndpoints.downloadImdsFileTemplateEndpoint}`,
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      let fileName = "imd_template.csv";
      // if (contentDisposition) {
      //   const match = contentDisposition.match(/filename="?(.+)"?/);
      //   if (match[1]) fileName = match[1];
      // }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      toast.error(
        `${error.message ? error.message : "Unable to download file!"}`
      );
    }
  };

  // Function for handling file change
  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile && uploadedFile.type === constant.allowedImdFileType) {
      setFile(uploadedFile);
    } else {
      toast.error("Please upload a valid CSV file.");
      setFile(null);
    }
  };

  // Function to open confirmation model
  const handleSubmit = () => {
    if (!file) {
      toast.error("Please upload a file first");
    } else {
      setOpenConfirm(true);
    }
  };

  const handleConfirmUpload = async (confirm) => {
    setOpenConfirm(false);
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("files", file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${serviceEndpoints.uploadImdsFileEndpoint}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFile(null);
      toast.success(response?.data?.data?.message);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(extractErrorMessage(error));
    } finally {
      setLoading(false);
      setOpenConfirm(false);
    }
  };

  return (
    <>
      <Container sx={{ marginTop: 2 }}>
        <div className="row">
          <div className="col-12">
            <Typography variant="h6 text" onClick={handleDownload}>
              Download template
            </Typography>
          </div>
        </div>
        <div className="row mt-3">
          {" "}
          <div className="col-12 ">
            {" "}
            <Button
              variant="contained"
              className="imd_buttons"
              component="label"
            >
              Upload CSV
              <input
                hidden
                accept=".csv"
                type="file"
                onChange={handleFileChange}
              />
            </Button>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <Button
              variant="contained"
              className="imd_buttons"
              onClick={handleSubmit}
              disabled={!file || loading}
            >
              {loading ? <CircularProgress size={20} /> : "Submit"}
            </Button>
          </div>
        </div>

        {/* {file && ( */}
        {file && (
          <Typography mt={2} fontStyle="italic" color="gray">
            Selected file: {file?.name}
          </Typography>
        )}
        {/* )} */}
        <ConfirmationDialog
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
          onConfirm={handleConfirmUpload}
          loading={loading}
        />
      </Container>
    </>
  );
};

export default UploadImdComponent;
